<template>
  <div class='main-sidebar zl_scrollbar' :class="{'main-sidebar-collapse':isCollapse}">
    <div class='main-sidebar-user' v-show='!isCollapse'>
      <div class='main-sidebar-user-img'>
        <img style='width: 100%;height: 100%;' src='../../assets/d_avatar.png' alt=''>
      </div>
      <div class='main-sidebar-user-info'>
        <div class='user-name'>{{ loginUserInfo.userName }}</div>
        <div class='flexl' style='height: 14px;'>
          <i style='display: inline-block;width: 12px;height: 12px;background-color: #18bc9c;border-radius: 50%;margin-right: 3px;'></i><span>在线</span>
        </div>
      </div>
    </div>
    <div v-show='isCollapse' style='padding: 10px;'>
      <div style='width: 25px;height: 25px;border-radius: 50%;overflow: hidden;margin: auto'>
        <img style='width: 100%;height: 100%;' src='../../assets/d_avatar.png' alt=''>
      </div>
    </div>
    <div class='menu_body zl_scrollbar' :style={height:menuHeight}>
      <zmr-menu :data='menuList' @menuClick='clickMenuFun' :router='true' :uniqueOpened='true' :defaultActive='defaultActive' :isCollapse='isCollapse'></zmr-menu>
    </div>
  </div>
</template>
<script setup>
import zmrMenu from '../menu/zmr_menu.vue'
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { isNotEmpty } from '../../common/js/comjs'
import { getCache } from '../../common/js/cache'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const store = useStore()
const menuHeight = ref('calc(100vh - 158px)')
const isCollapse = ref(store.state.sidebarStatus)
const defaultActive = ref(String(store.state.activeMenuId))
const menuList = ref(getCache('userAuth'))
const loginUserInfo = ref(getCache('userInfo'))
watch(() => store.state.sidebarStatus, (newData, oldData) => {
  if (isNotEmpty(newData) && newData !== oldData) {
    isCollapse.value = newData
    if (newData) {
      menuHeight.value = 'calc(100vh - 95px)'
    } else {
      menuHeight.value = 'calc(100vh - 155)'
    }
  }
})

watch(() => store.state.activeMenuId, (newData, oldData) => {
  if (newData !== oldData) {
    defaultActive.value = String(newData)
  }
})


//菜单点击返回
const clickMenuFun = () => {
}

//页面刷新设置菜单选中
const windowRefreshSetDefaultActiveFun = () => {
  let activeMenuItems = urlToMenuId(menuList.value, route.path)
  if (activeMenuItems.length > 0) {
    //设置页面的按钮权限
    let rank = []
    if (isNotEmpty(activeMenuItems[0].children) && activeMenuItems[0].children.length > 0) {
      for (let i in activeMenuItems[0].children) {
        let iData = activeMenuItems[0].children[i]
        if (iData.menuType === 'action' && isNotEmpty(iData.code)) {
          rank.push(iData.code)
        }
      }
    }
    store.commit('setPageRank', rank)
    store.commit('commitSetMenu', activeMenuItems[0])
    defaultActive.value = String(activeMenuItems[0].id)
  } else {
    selectNavFun(menuList.value[0])
  }
}

//菜单选择
const selectNavFun = (item, type) => {
  if (isNotEmpty(item.path) && type !== 'children') {
    let routerPath = ''
    if (item.path.indexOf('/') !== 0) {
      routerPath = '/' + item.path
    } else {
      routerPath = item.path
    }
    router.push({
      path: routerPath,
    })
  }
  if (isNotEmpty(item.children) && item.menuType === 'menu') {
    let menuEndItem = getNodeChildrenEnd(item.children)
    if (type !== 'children') {
      let routerPath = ''
      if (menuEndItem.path.indexOf('/') !== 0) {
        routerPath = '/' + menuEndItem.path
      } else {
        routerPath = menuEndItem.path
      }
      router.push({
        path: routerPath,
      })
      store.commit('commitSetMenu', menuEndItem)
      defaultActive.value = String(menuEndItem.id)
    }
  } else {
    let routerPath = ''
    if (item.path.indexOf('/') !== 0) {
      routerPath = '/' + item.path
    } else {
      routerPath = item.path
    }
    router.push({
      path: routerPath,
    })
    store.commit('commitSetMenu', item)
    defaultActive.value = String(item.id)
  }
}


//获取树结构的第一个节点的最有一个节点
const getNodeChildrenEnd = (data) => {
  if (!Array.isArray(data)) {
    data = [data]
  }
  for (let i in data) {
    if (i === '0') {
      let dataItem = data[i]
      if (isNotEmpty(dataItem.children) && dataItem.children.length > 0 && dataItem.menuType === 'menu') {
        return getNodeChildrenEnd(dataItem.children)
      } else {
        return dataItem
      }
    } else {
      break
    }
  }
}

const urlToMenuId = (menuList = [], path = '') => {
  let returnData = []
  if (!isNotEmpty(path)) {
    return returnData
  }
  if(path.indexOf('/') === 0){
    path = path.substr(1,path.length - 1);
  }
  for (let i in menuList) {
    let itemData = menuList[i]
    if (isNotEmpty(itemData.path) && itemData.path === path) {
      returnData.push(itemData)
      break
    } else {
      if (isNotEmpty(itemData.children) && itemData.children.length > 0) {
        let chilrenReturnData = urlToMenuId(itemData.children, path)
        if (chilrenReturnData.length > 0) {
          returnData = chilrenReturnData
          returnData.push(itemData)
          break
        }
      }
    }
  }
  returnData = [];
  return returnData
}
windowRefreshSetDefaultActiveFun()


</script>
<style scoped lang='less'>
.menu_body {
  overflow-y: auto;
}

.main-sidebar {
  transition: width 0.3s ease-in-out;
  background-color: var(--zl-menu-bg-color);
  width: var(--zl-menu-width);
  height: calc(100vh - 61px);
  box-shadow: rgba(0, 0, 0, 0.03) 7px 0 14px;
  overflow-y: auto;
  border-top: 1px solid #2768cc;
  box-sizing: border-box;

  .main-sidebar-user {
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 65px;
    margin-bottom: 15px;
    margin-top: 15px;

    .main-sidebar-user-img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
    }

    .main-sidebar-user-info {
      padding: 5px 5px 5px 15px;
      box-sizing: border-box;
      flex: 1;
      color: var(--zl-w-text-color);

      .user-name {
        font-weight: 600;
        margin-bottom: 7px;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
  }
}

.main-sidebar-collapse {
  width: var(--zl-menu-collapse-width);
}
</style>
